// extracted by mini-css-extract-plugin
export var container = "_4r-0";
export var fallback = "_4r-5";
export var fallbackIcon = "_4r-6";
export var hidden = "_4r-2";
export var image = "_4r-3";
export var loaded = "_4r-4";
export var placeholder = "_4r-1";